// H2.8 — config del cliente activo, cargada de /api/g/v2/clients/me/config.
// VITE_PROYECTO desapareció: el proyecto vive en el token de sesión (D3/T5).
const KEY = 'client_config';

export const clientStore = {
  set(config) {
    sessionStorage.setItem(KEY, JSON.stringify(config));
  },
  get() {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  },
  getProjectId() {
    return this.get()?.id || null;
  },
  clear() {
    sessionStorage.removeItem(KEY);
  },
};
